// Config object to be passed to Msal on creation
export const msalConfig = {
  auth: {
    clientId: window.configs.CLIENTID,
    authority: window.configs.AUTHORITY,
  },
};

// Add here scopes for id token to be used at MS Identity Platform endpoints.
export const loginRequest = {
  scopes: ["User.Read"],
};
